"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/echartsNew/index"));
var _permission = require("@/utils/permission");
var _orderListApi = require("@/api/orderListApi");
var _statistic = require("@/api/statistic");
var _mock = require("./mock");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var USER_METRIC_TIPS = {
  visitUsers: '访问过小程序/页面的独立用户总数。同一用户多次访问只计1次',
  newUsers: '首次访问小程序/页面的用户数。',
  payUsers: '成功完成支付的独立用户数。同一用户多笔订单计多次'
};
var TRADE_METRIC_TIPS = {
  orderCount: '支付成功的订单总笔数。同一用户多笔订单分别计入（订单状态除开“已取消”，“退款成功”）',
  orderAmount: '支付成功的订单总金额，反映交易规模（订单状态除开“已取消”，“退款成功”，也不包含"部分退款"中已退款商品金额）',
  aov: '每笔订单的平均成交金额，反映用户消费深度',
  newAmount: '首次下单用户贡献的成交金额，衡量新客价值（订单状态除开“已取消”，“退款成功”，也不包含"部分退款"中已退款商品金额）',
  oldAmount: '历史有成交记录的用户贡献的成交金额，衡量老客贡献（订单状态除开“已取消”，“退款成功”，也不包含"部分退款"中已退款商品金额）',
  orderCvr: '访问用户中成功提交订单的比例，反映从访问到下单的效率',
  payCvr: '访问用户中成功支付的比例，反映从访问到支付的最终转化效率',
  refundAmount: '已退款的订单总金额，反映售后资金流出',
  grossMargin: '成交订单的毛利占成交金额的比例，反映盈利能力',
  afterSale: '用户售后申请的总单数，反映售后压力'
};
var COMPARE_TIPS = {
  user: {
    较昨日: '今日数据对比昨日同期的增减幅度，反映环比变化',
    环比: '当前统计周期与上一个相邻周期的数据对比，反映指标的短期连续变化趋势。',
    年同比: '当前统计周期与上年同期的数据对比，反映指标的年度变化趋势，能剔除季节性波动影响。'
  },
  trade: {
    较昨日: '今日数据对比昨日同期的增减幅度，反映日环比变化',
    环比: '当前统计周期与上一个相邻周期的数据对比，反映指标的短期连续变化趋势。',
    年同比: '当前统计周期与上年同期的数据对比，反映指标的年度变化趋势，能剔除季节性波动影响。'
  }
};
var CHART_TIPS = {
  cartUnpaid: '该商品被用户加入购物车但未最终下单的总次数（含同一用户多次加购同一商品）',
  visitUsersHourly: '每个整点时段内，访问过小程序/页面的独立用户数。同一用户在该时段内多次访问只计1次',
  payOrdersHourly: '每个整点时段内，用户支付成功的订单总笔数。同一用户多笔订单分别计入',
  pv: '页面被加载/打开的总次数。同一用户多次刷新或重复进入页面，PV均累加',
  clicks: '每次点击独立计数，同一用户多次点击分别计入',
  stayDuration: '用户在页面中停留的时间分段，用于分析用户粘性和页面内容吸引力'
};
var ZONE_METRIC_TIPS = {
  clicks: '每次点击独立计数，同一用户多次点击分别计入',
  pv: '页面被加载/打开的总次数。同一用户多次刷新或重复进入页面，PV均累加',
  avgStay: '用户在页面中停留的时间分段，用于分析用户粘性和页面内容吸引力'
};
function emptyCompareList(type) {
  var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'user';
  var t = Number(type) || 1;
  var tips = COMPARE_TIPS[scope] || COMPARE_TIPS.user;
  var attach = function attach(text) {
    return {
      text: text,
      rate: '--',
      tip: tips[text]
    };
  };
  if (t === 1) return [attach('较昨日')];
  if (t === 4) return [attach('年同比')];
  return [attach('环比'), attach('年同比')];
}
function emptyUserMetrics() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var compareList = emptyCompareList(type, 'user');
  return {
    dataTime: '--',
    list: [{
      key: 'visitUsers',
      label: '访问人数',
      value: '--',
      unit: '人',
      tip: USER_METRIC_TIPS.visitUsers,
      compareList: compareList
    }, {
      key: 'newUsers',
      label: '新增用户',
      value: '--',
      unit: '人',
      tip: USER_METRIC_TIPS.newUsers,
      compareList: compareList
    }, {
      key: 'payUsers',
      label: '支付用户',
      value: '--',
      unit: '人',
      tip: USER_METRIC_TIPS.payUsers,
      compareList: compareList
    }]
  };
}
function emptyTradeMetrics() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var compareList = emptyCompareList(type, 'trade');
  return {
    dataTime: '--',
    list: [{
      key: 'orderCount',
      label: '净成交订单数',
      value: '--',
      unit: '单',
      tip: TRADE_METRIC_TIPS.orderCount,
      compareList: compareList
    }, {
      key: 'orderAmount',
      label: '净成交订单金额',
      value: '--',
      unit: '元',
      tip: TRADE_METRIC_TIPS.orderAmount,
      compareList: compareList
    }, {
      key: 'aov',
      label: '客单价',
      value: '--',
      unit: '元',
      tip: TRADE_METRIC_TIPS.aov,
      compareList: compareList
    }, {
      key: 'newAmount',
      label: '新客户净成交金额',
      value: '--',
      unit: '元',
      tip: TRADE_METRIC_TIPS.newAmount,
      compareList: compareList
    }, {
      key: 'oldAmount',
      label: '老客户净成交金额',
      value: '--',
      unit: '元',
      tip: TRADE_METRIC_TIPS.oldAmount,
      compareList: compareList
    }, {
      key: 'orderCvr',
      label: '下单转化率',
      value: '--',
      unit: '%',
      tip: TRADE_METRIC_TIPS.orderCvr,
      compareList: compareList
    }, {
      key: 'payCvr',
      label: '支付转化率',
      value: '--',
      unit: '%',
      tip: TRADE_METRIC_TIPS.payCvr,
      compareList: compareList
    }, {
      key: 'refundAmount',
      label: '退款金额',
      value: '--',
      unit: '元',
      tip: TRADE_METRIC_TIPS.refundAmount,
      compareList: compareList
    }, {
      key: 'grossMargin',
      label: '毛利率',
      value: '--',
      unit: '%',
      tip: TRADE_METRIC_TIPS.grossMargin,
      compareList: compareList
    }, {
      key: 'afterSale',
      label: '售后申请单量',
      value: '--',
      unit: '',
      tip: TRADE_METRIC_TIPS.afterSale,
      compareList: compareList
    }]
  };
}
function emptyZoneUserMetrics() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var compareList = emptyCompareList(type);
  return {
    list: [{
      key: 'clicks',
      label: '点击量',
      value: '--',
      unit: '',
      tip: ZONE_METRIC_TIPS.clicks,
      compareList: compareList
    }, {
      key: 'pv',
      label: '浏览PV',
      value: '--',
      unit: '',
      tip: ZONE_METRIC_TIPS.pv,
      compareList: compareList
    }, {
      key: 'avgStay',
      label: '平均停留时长',
      value: '--',
      unit: '',
      tip: ZONE_METRIC_TIPS.avgStay,
      compareList: compareList
    }]
  };
}
function emptyHourlyTrend() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var hours = Array.from({
    length: 24
  }, function (_, i) {
    return String(i).padStart(2, '0') + ':00';
  });
  return {
    date: date,
    updateTime: '--',
    hours: hours,
    visitUsers: Array(24).fill(null),
    orderCounts: Array(24).fill(null),
    currentHourLabel: '当前时间'
  };
}
function emptyZonePvTrend() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var hours = Array.from({
    length: 24
  }, function (_, i) {
    return String(i).padStart(2, '0') + ':00';
  });
  return {
    date: date,
    updateTime: '--',
    hours: hours,
    pv: Array(24).fill(null),
    clicks: Array(24).fill(null)
  };
}
var _default = exports.default = {
  name: 'DataOverview',
  components: {
    echartsNew: _index.default
  },
  data: function data() {
    return {
      activeTab: 'core',
      miniAppIds: [],
      decorationPageId: '',
      miniAppOptions: [],
      decorationPageOptions: [],
      decorationPageLoading: false,
      decorationPageLoadingMore: false,
      decorationPageLoaded: false,
      decorationPagePage: 1,
      decorationPageLimit: 50,
      decorationPageKeyword: '',
      decorationPageNoMore: false,
      dateRangeOptions: _mock.dateRangeOptions,
      zoneDateRangeOptions: _mock.zoneDateRangeOptions,
      orderTypeOptions: [],
      userTypeOptions: _mock.userTypeOptions,
      userDateRange: 1,
      tradeDateRange: 1,
      sourceDateRange: 1,
      zoneDateRange: 1,
      userCustomRange: [],
      tradeCustomRange: [],
      zoneCustomRange: [],
      orderType: '',
      sourceUserType: 'all',
      sourceMetric: 'visitUsers',
      orderTrendDate: '',
      realtimeDate: '',
      zoneTrendDate: '',
      userMetrics: emptyUserMetrics(1),
      tradeMetrics: emptyTradeMetrics(1),
      visitSource: {
        visitUsers: [],
        openTimes: []
      },
      cartTop5: {
        dataTime: '--',
        list: []
      },
      orderTrend: emptyHourlyTrend(),
      realtime: emptyHourlyTrend(),
      zoneUserMetrics: emptyZoneUserMetrics(1),
      zonePvTrend: emptyZonePvTrend(),
      zoneStay: {
        updateTime: '--',
        list: []
      },
      orderTrendOption: {},
      realtimeOption: {},
      sourceOption: {},
      cartOption: {},
      zonePvOption: {},
      zoneStayOption: {},
      chartTips: CHART_TIPS,
      userLoading: true,
      tradeLoading: true,
      cartLoading: true,
      realtimeLoading: true,
      zoneUserLoading: false,
      zonePvLoading: false,
      zonePvChartTick: 0,
      zoneStayLoading: false
    };
  },
  watch: {
    activeTab: function activeTab(val) {
      var _this = this;
      this.$nextTick(function () {
        if (val === 'zone') {
          _this.ensureDecorationPages();
          _this.fetchTrafficData();
          _this.fetchDurationDistribution();
          _this.fetchHourlyTrafficTrend().then(function () {
            _this.resizeCharts();
          });
        } else {
          // this.buildOrderTrendOption();
          _this.buildRealtimeOption();
          _this.buildSourceOption();
          _this.buildCartOption();
          _this.resizeCharts();
        }
      });
    },
    miniAppIds: function miniAppIds() {
      this.fetchUserData();
      this.fetchTransactionData();
      this.fetchCartProductTop();
      // this.fetchOrderHourlyTrend();
      this.fetchPayHourlyTrend();
      if (this.activeTab === 'zone') {
        this.fetchTrafficData();
        this.fetchDurationDistribution();
        this.fetchHourlyTrafficTrend();
      }
    },
    decorationPageId: function decorationPageId() {
      if (this.activeTab === 'zone') {
        this.fetchTrafficData();
        this.fetchDurationDistribution();
        this.fetchHourlyTrafficTrend();
      }
    }
  },
  created: function created() {
    var today = this.formatDateYmd(new Date());
    this.orderTrendDate = today;
    this.realtimeDate = today;
    this.zoneTrendDate = today;
    if (!this.hasCoreTabPermi() && this.hasZoneTabPermi()) this.activeTab = 'zone';
    this._selectScroll = {};
    this.fetchMiniAppList();
    this.fetchOrderTypeOptions();
    this.fetchUserData();
    this.fetchTransactionData();
    this.fetchCartProductTop();
    // this.fetchOrderHourlyTrend();
    this.fetchPayHourlyTrend();
    // this.buildOrderTrendOption();
    this.buildRealtimeOption();
    this.buildSourceOption();
    this.buildCartOption();
    this.buildZonePvOption();
    this.buildZoneStayOption();
  },
  beforeDestroy: function beforeDestroy() {
    this.unbindSelectScroll('decorationPageSelect');
  },
  methods: {
    checkPermi: _permission.checkPermi,
    hasCoreTabPermi: function hasCoreTabPermi() {
      return (0, _permission.checkPermi)(['admin:core:overview:user:data', 'admin:core:overview:transaction:data', 'admin:core:overview:cart:product:top', 'admin:core:overview:hourly:pay:trend']);
    },
    hasZoneTabPermi: function hasZoneTabPermi() {
      return (0, _permission.checkPermi)(['admin:core:overview:traffic:data', 'admin:core:overview:hourly:traffic:trend', 'admin:core:overview:duration:distribution']);
    },
    fetchOrderTypeOptions: function () {
      var _fetchOrderTypeOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _orderListApi.getOrderTypes)();
            case 1:
              res = _context.v;
              this.orderTypeOptions = res || [];
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.orderTypeOptions = [];
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function fetchOrderTypeOptions() {
        return _fetchOrderTypeOptions.apply(this, arguments);
      }
      return fetchOrderTypeOptions;
    }(),
    fetchMiniAppList: function () {
      var _fetchMiniAppList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, list, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _statistic.getBusinessList)();
            case 1:
              res = _context2.v;
              list = Array.isArray(res) ? res : res && res.list || [];
              this.miniAppOptions = list.filter(function (item) {
                return item && item.customerId != null && item.customerId !== '';
              }).map(function (item) {
                return {
                  label: item.customerName || item.appName,
                  value: item.customerId
                };
              });
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              this.miniAppOptions = [];
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function fetchMiniAppList() {
        return _fetchMiniAppList.apply(this, arguments);
      }
      return fetchMiniAppList;
    }(),
    getCustomerIdsParam: function getCustomerIdsParam() {
      if (!this.miniAppIds || !this.miniAppIds.length) return undefined;
      return this.miniAppIds.filter(function (id) {
        return id != null && id !== '';
      }).join(',');
    },
    resetSelectQuery: function resetSelectQuery(refName) {
      var _this2 = this;
      var triggerFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.$nextTick(function () {
        var select = _this2.$refs[refName];
        if (!select) return;
        select.query = '';
        select.previousQuery = '';
        var input = select.$el && select.$el.querySelector('input.el-select__input');
        if (input) input.value = '';
        if (triggerFilter && typeof select.handleQueryChange === 'function') {
          select.handleQueryChange('');
        }
      });
    },
    bindSelectScroll: function bindSelectScroll(refName, onReachBottom) {
      var _this3 = this;
      this.$nextTick(function () {
        var select = _this3.$refs[refName];
        if (!select) return;
        var popper = select.$refs.popper && (select.$refs.popper.$el || select.$refs.popper);
        var root = popper || select.popperElm;
        if (!root) return;
        var wrap = root.querySelector('.el-select-dropdown__wrap') || root.querySelector('.el-scrollbar__wrap');
        if (!wrap) return;
        _this3.unbindSelectScroll(refName);
        var handler = function handler() {
          if (wrap.scrollHeight - wrap.scrollTop - wrap.clientHeight > 16) return;
          onReachBottom();
        };
        wrap.addEventListener('scroll', handler);
        _this3._selectScroll[refName] = {
          wrap: wrap,
          handler: handler
        };
      });
    },
    unbindSelectScroll: function unbindSelectScroll(refName) {
      var rec = this._selectScroll && this._selectScroll[refName];
      if (!rec) return;
      rec.wrap.removeEventListener('scroll', rec.handler);
      this._selectScroll[refName] = null;
    },
    appendUniqueOptions: function appendUniqueOptions(oldList, nextList) {
      var set = new Set((oldList || []).map(function (item) {
        return item.value;
      }));
      return (oldList || []).concat((nextList || []).filter(function (item) {
        return !set.has(item.value);
      }));
    },
    keepSelectedDecoration: function keepSelectedDecoration(nextList) {
      var selected = this.decorationPageId;
      if (selected == null || selected === '') return nextList;
      if (nextList.some(function (item) {
        return item.value === selected;
      })) return nextList;
      var old = (this.decorationPageOptions || []).find(function (item) {
        return item.value === selected;
      });
      return old ? nextList.concat(old) : nextList;
    },
    ensureDecorationPages: function ensureDecorationPages() {
      if (!this.decorationPageLoaded && !this.decorationPageLoading) {
        this.decorationPagePage = 1;
        this.decorationPageNoMore = false;
        this.fetchDecorationPages({
          reset: true
        });
      }
    },
    searchDecorationPages: function searchDecorationPages(keyword) {
      this.decorationPageKeyword = (keyword || '').trim();
      this.decorationPagePage = 1;
      this.decorationPageNoMore = false;
      this.fetchDecorationPages({
        reset: true
      });
    },
    handleDecorationClear: function handleDecorationClear() {
      this.decorationPageId = '';
      this.decorationPageKeyword = '';
      this.decorationPagePage = 1;
      this.decorationPageNoMore = false;
      this.resetSelectQuery('decorationPageSelect', false);
      this.fetchDecorationPages({
        reset: true
      });
    },
    handleDecorationVisibleChange: function handleDecorationVisibleChange(visible) {
      if (visible) {
        this.ensureDecorationPages();
        this.bindSelectScroll('decorationPageSelect', this.loadMoreDecorationPages);
        return;
      }
      this.resetSelectQuery('decorationPageSelect', false);
      if ((this.decorationPageId === '' || this.decorationPageId == null) && this.decorationPageKeyword) {
        this.decorationPageKeyword = '';
        this.decorationPagePage = 1;
        this.decorationPageNoMore = false;
        this.fetchDecorationPages({
          reset: true
        });
      }
    },
    loadMoreDecorationPages: function loadMoreDecorationPages() {
      if (this.decorationPageLoading || this.decorationPageLoadingMore || this.decorationPageNoMore) return;
      this.decorationPagePage += 1;
      this.fetchDecorationPages({
        reset: false
      });
    },
    fetchDecorationPages: function () {
      var _fetchDecorationPages = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _ref,
          _ref$reset,
          reset,
          params,
          res,
          pageData,
          list,
          mapped,
          oldLen,
          added,
          total,
          _args3 = arguments,
          _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _ref = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref$reset = _ref.reset, reset = _ref$reset === void 0 ? true : _ref$reset;
              if ((0, _permission.checkPermi)(['admin:core:overview:design:auth:page'])) {
                _context3.n = 1;
                break;
              }
              this.decorationPageLoading = false;
              this.decorationPageLoadingMore = false;
              return _context3.a(2);
            case 1:
              if (reset) this.decorationPageLoading = true;else this.decorationPageLoadingMore = true;
              _context3.p = 2;
              params = {
                page: this.decorationPagePage,
                limit: this.decorationPageLimit
              };
              if (this.decorationPageKeyword) params.urlName = this.decorationPageKeyword;
              _context3.n = 3;
              return (0, _statistic.overviewDesignAuthPageApi)(params);
            case 3:
              res = _context3.v;
              pageData = res && res.list ? res : res && res.data || res || {};
              list = pageData.list || (Array.isArray(res) ? res : []) || [];
              mapped = list.map(function (item) {
                return {
                  label: item.urlName || '装修页' + item.id,
                  value: item.id
                };
              });
              oldLen = (this.decorationPageOptions || []).length;
              if (reset) {
                this.decorationPageOptions = this.keepSelectedDecoration(mapped);
              } else {
                this.decorationPageOptions = this.appendUniqueOptions(this.decorationPageOptions, mapped);
              }
              added = reset ? mapped.length : this.decorationPageOptions.length - oldLen;
              total = pageData.total;
              this.decorationPageNoMore = !mapped.length || added === 0 || mapped.length < this.decorationPageLimit || typeof total === 'number' && this.decorationPageOptions.length >= total;
              this.decorationPageLoaded = true;
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              if (reset) this.decorationPageOptions = [];else this.decorationPagePage = Math.max(1, this.decorationPagePage - 1);
              this.decorationPageNoMore = true;
            case 5:
              _context3.p = 5;
              this.decorationPageLoading = false;
              this.decorationPageLoadingMore = false;
              return _context3.f(5);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 4, 5, 6]]);
      }));
      function fetchDecorationPages() {
        return _fetchDecorationPages.apply(this, arguments);
      }
      return fetchDecorationPages;
    }(),
    pickDataUpdateTime: function pickDataUpdateTime(res) {
      if (!res || _typeof(res) !== 'object' || Array.isArray(res)) return '--';
      var t = res.dataUpdateTime;
      if (t == null || t === '') return '--';
      return t;
    },
    formatDateYmd: function formatDateYmd(date) {
      var d = date instanceof Date ? date : new Date(date);
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    },
    formatRate: function formatRate(rate) {
      if (rate == null || rate === '') return '--';
      var str = String(rate).trim();
      if (!str || str === '--') return '--';
      return str.endsWith('%') ? str : str + '%';
    },
    compareClass: function compareClass(rate) {
      if (rate == null || rate === '') return 'flat';
      var str = String(rate).trim();
      if (!str || str === '--') return 'flat';
      if (str.startsWith('-')) return 'down';
      if (str.startsWith('+')) return 'up';
      var num = Number(str.replace(/%/g, ''));
      if (!Number.isNaN(num) && num > 0) return 'up';
      if (!Number.isNaN(num) && num < 0) return 'down';
      return 'flat';
    },
    buildOverviewPeriodParams: function buildOverviewPeriodParams(type, customRange) {
      var tt = Number(type) || 1;
      if (tt === 5) {
        var range = customRange || [];
        if (!range[0] || !range[1]) {
          this.$message.warning('自定义时间请选择开始和结束时间');
          return null;
        }
      }
      var params = {
        type: tt
      };
      var customerIds = this.getCustomerIdsParam();
      if (customerIds) params.customerIds = customerIds;
      if (tt === 5) {
        params.startTime = customRange[0];
        params.endTime = customRange[1];
      }
      return params;
    },
    pickRatioString: function pickRatioString(data, prefixes, suffixes) {
      var prefixList = Array.isArray(prefixes) ? prefixes : [prefixes];
      for (var i = 0; i < prefixList.length; i += 1) {
        var prefix = prefixList[i];
        for (var j = 0; j < suffixes.length; j += 1) {
          var raw = data[prefix + suffixes[j]];
          if (raw == null || raw === '') continue;
          return String(raw).trim();
        }
      }
      return '--';
    },
    buildCompareList: function buildCompareList(data, prefixes, type) {
      var scope = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'user';
      var tt = Number(type) || 1;
      var tips = COMPARE_TIPS[scope] || COMPARE_TIPS.user;
      var attach = function attach(text, rate) {
        return {
          text: text,
          rate: rate,
          tip: tips[text]
        };
      };
      if (tt === 1) {
        return [attach('较昨日', this.pickRatioString(data, prefixes, ['Ratio']))];
      }
      if (tt === 4) {
        return [attach('年同比', this.pickRatioString(data, prefixes, ['YearOnYearRatio', 'ChainRatioYearOnYearRatio']))];
      }
      return [attach('环比', this.pickRatioString(data, prefixes, ['ChainRatio'])), attach('年同比', this.pickRatioString(data, prefixes, ['YearOnYearRatio', 'ChainRatioYearOnYearRatio']))];
    },
    formatMoneyParts: function formatMoneyParts(val) {
      if (val == null || val === '') return {
        value: '--',
        unit: '元'
      };
      var num = Number(val);
      if (Number.isNaN(num)) return {
        value: String(val),
        unit: ''
      };
      if (Math.abs(num) >= 10000) {
        return {
          value: '¥' + (num / 10000).toFixed(2),
          unit: '万'
        };
      }
      return {
        value: '¥' + num.toFixed(2),
        unit: '元'
      };
    },
    formatPercentValue: function formatPercentValue(val) {
      if (val == null || val === '') return '--';
      var str = String(val).replace(/%/g, '');
      var num = Number(str);
      if (Number.isNaN(num)) return String(val);
      return String(num);
    },
    formatNumberDisplay: function formatNumberDisplay(val) {
      if (val == null || val === '') return '--';
      var num = Number(val);
      if (Number.isNaN(num)) return String(val);
      return num.toLocaleString();
    },
    formatStayDuration: function formatStayDuration(val) {
      if (val == null || val === '') return '--';
      if (typeof val === 'string' && (val.includes(':') || Number.isNaN(Number(val)))) return val;
      var total = Math.max(0, Math.floor(Number(val)));
      if (Number.isNaN(total)) return String(val);
      var h = Math.floor(total / 3600);
      var m = Math.floor(total % 3600 / 60);
      var s = total % 60;
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      if (h > 0) return pad(h) + ':' + pad(m) + ':' + pad(s);
      return pad(m) + ':' + pad(s);
    },
    pickNumber: function pickNumber() {
      for (var _len = arguments.length, vals = new Array(_len), _key = 0; _key < _len; _key++) {
        vals[_key] = arguments[_key];
      }
      for (var i = 0; i < vals.length; i += 1) {
        if (vals[i] == null || vals[i] === '') continue;
        var num = Number(vals[i]);
        if (!Number.isNaN(num)) return num;
      }
      return null;
    },
    pickValueByKeys: function pickValueByKeys(data, keys) {
      if (!data || _typeof(data) !== 'object') return undefined;
      for (var i = 0; i < keys.length; i += 1) {
        var value = data[keys[i]];
        if (value != null && value !== '') return value;
      }
      return undefined;
    },
    pickNumberByKeys: function pickNumberByKeys(data, keys) {
      return this.pickNumber.apply(this, _toConsumableArray(keys.map(function (key) {
        return data && data[key];
      })));
    },
    pickFirstArray: function pickFirstArray() {
      for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        values[_key2] = arguments[_key2];
      }
      for (var i = 0; i < values.length; i += 1) {
        if (Array.isArray(values[i])) return values[i];
      }
      return [];
    },
    parseHourIndex: function parseHourIndex(value) {
      if (value == null || value === '') return null;
      if (value instanceof Date) return value.getHours();
      if (typeof value === 'number') return Math.floor(value);
      var str = String(value).trim();
      if (/^\d{1,2}$/.test(str)) return Number(str);
      if (/^\d{10,13}$/.test(str)) return new Date(Number(str.length === 10 ? str + '000' : str)).getHours();
      var timeMatch = str.match(/(?:^|\s|T)(\d{1,2}):\d{1,2}/);
      if (timeMatch) return Number(timeMatch[1]);
      var date = new Date(str.replace(/-/g, '/'));
      return Number.isNaN(date.getTime()) ? null : date.getHours();
    },
    fetchUserData: function () {
      var _fetchUserData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var params, res, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if ((0, _permission.checkPermi)(['admin:core:overview:user:data'])) {
                _context4.n = 1;
                break;
              }
              this.userLoading = false;
              return _context4.a(2, false);
            case 1:
              params = this.buildOverviewPeriodParams(this.userDateRange, this.userCustomRange);
              if (params) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2, false);
            case 2:
              this.userLoading = true;
              _context4.p = 3;
              _context4.n = 4;
              return (0, _statistic.overviewUserDataApi)(params);
            case 4:
              res = _context4.v;
              this.userMetrics = this.normalizeUserData(res, params.type);
              return _context4.a(2, true);
            case 5:
              _context4.p = 5;
              _t4 = _context4.v;
              this.userMetrics = emptyUserMetrics(params.type);
              return _context4.a(2, false);
            case 6:
              _context4.p = 6;
              this.userLoading = false;
              return _context4.f(6);
            case 7:
              return _context4.a(2);
          }
        }, _callee4, this, [[3, 5, 6, 7]]);
      }));
      function fetchUserData() {
        return _fetchUserData.apply(this, arguments);
      }
      return fetchUserData;
    }(),
    normalizeUserData: function normalizeUserData(res, type) {
      var data = res && _typeof(res) === 'object' && !Array.isArray(res) ? res : {};
      var visit = this.pickNumber(data.visitUserCount, data.visitUsers, data.visitUserNum, data.visitCount);
      var neu = this.pickNumber(data.newUserCount, data.newUsers, data.newUserNum, data.addUserCount);
      var pay = this.pickNumber(data.payUserCount, data.payUsers, data.payUserNum, data.paidUserCount);
      return {
        dataTime: this.pickDataUpdateTime(data),
        list: [{
          key: 'visitUsers',
          label: '访问人数',
          value: this.formatNumberDisplay(visit),
          unit: '人',
          tip: USER_METRIC_TIPS.visitUsers,
          compareList: this.buildCompareList(data, ['visitUserCount', 'visitUsers'], type, 'user')
        }, {
          key: 'newUsers',
          label: '新增用户',
          value: this.formatNumberDisplay(neu),
          unit: '人',
          tip: USER_METRIC_TIPS.newUsers,
          compareList: this.buildCompareList(data, ['newUserCount', 'newUsers'], type, 'user')
        }, {
          key: 'payUsers',
          label: '支付用户',
          value: this.formatNumberDisplay(pay),
          unit: '人',
          tip: USER_METRIC_TIPS.payUsers,
          compareList: this.buildCompareList(data, ['payUserCount', 'payUsers'], type, 'user')
        }]
      };
    },
    fetchTransactionData: function () {
      var _fetchTransactionData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var params, res, _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if ((0, _permission.checkPermi)(['admin:core:overview:transaction:data'])) {
                _context5.n = 1;
                break;
              }
              this.tradeLoading = false;
              return _context5.a(2, false);
            case 1:
              params = this.buildOverviewPeriodParams(this.tradeDateRange, this.tradeCustomRange);
              if (params) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, false);
            case 2:
              if (this.orderType !== '' && this.orderType != null) params.orderType = this.orderType;
              this.tradeLoading = true;
              _context5.p = 3;
              _context5.n = 4;
              return (0, _statistic.overviewTransactionDataApi)(params);
            case 4:
              res = _context5.v;
              this.tradeMetrics = this.normalizeTransactionData(res, params.type);
              return _context5.a(2, true);
            case 5:
              _context5.p = 5;
              _t5 = _context5.v;
              this.tradeMetrics = emptyTradeMetrics(params.type);
              return _context5.a(2, false);
            case 6:
              _context5.p = 6;
              this.tradeLoading = false;
              return _context5.f(6);
            case 7:
              return _context5.a(2);
          }
        }, _callee5, this, [[3, 5, 6, 7]]);
      }));
      function fetchTransactionData() {
        return _fetchTransactionData.apply(this, arguments);
      }
      return fetchTransactionData;
    }(),
    normalizeTransactionData: function normalizeTransactionData(res, type) {
      var data = res && _typeof(res) === 'object' && !Array.isArray(res) ? res : {};
      var orderCount = this.pickNumber(data.transactionOrderCount);
      var orderAmount = this.formatMoneyParts(data.transactionOrderAmount);
      var aov = this.formatMoneyParts(data.averageOrderAmount);
      var newAmount = this.formatMoneyParts(data.newUserOrderAmount);
      var oldAmount = this.formatMoneyParts(data.oldUserOrderAmount);
      var refund = this.formatMoneyParts(data.refundAmount);
      var afterSale = this.pickNumber(data.aftersaleOrderCount);
      return {
        dataTime: this.pickDataUpdateTime(data),
        list: [{
          key: 'orderCount',
          label: '净成交订单数',
          value: this.formatNumberDisplay(orderCount),
          unit: '单',
          tip: TRADE_METRIC_TIPS.orderCount,
          compareList: this.buildCompareList(data, 'transactionOrderCount', type, 'trade')
        }, {
          key: 'orderAmount',
          label: '净成交订单金额',
          value: orderAmount.value,
          unit: orderAmount.unit,
          tip: TRADE_METRIC_TIPS.orderAmount,
          compareList: this.buildCompareList(data, 'transactionOrderAmount', type, 'trade')
        }, {
          key: 'aov',
          label: '客单价',
          value: aov.value,
          unit: aov.unit,
          tip: TRADE_METRIC_TIPS.aov,
          compareList: this.buildCompareList(data, 'averageOrderAmount', type, 'trade')
        }, {
          key: 'newAmount',
          label: '新客户净成交金额',
          value: newAmount.value,
          unit: newAmount.unit,
          tip: TRADE_METRIC_TIPS.newAmount,
          compareList: this.buildCompareList(data, 'newUserOrderAmount', type, 'trade')
        }, {
          key: 'oldAmount',
          label: '老客户净成交金额',
          value: oldAmount.value,
          unit: oldAmount.unit,
          tip: TRADE_METRIC_TIPS.oldAmount,
          compareList: this.buildCompareList(data, 'oldUserOrderAmount', type, 'trade')
        }, {
          key: 'orderCvr',
          label: '下单转化率',
          value: this.formatPercentValue(data.orderConversionRate),
          unit: '%',
          tip: TRADE_METRIC_TIPS.orderCvr,
          compareList: this.buildCompareList(data, 'orderConversionRate', type, 'trade')
        }, {
          key: 'payCvr',
          label: '支付转化率',
          value: this.formatPercentValue(data.payConversionRate),
          unit: '%',
          tip: TRADE_METRIC_TIPS.payCvr,
          compareList: this.buildCompareList(data, 'payConversionRate', type, 'trade')
        }, {
          key: 'refundAmount',
          label: '退款金额',
          value: refund.value,
          unit: refund.unit,
          tip: TRADE_METRIC_TIPS.refundAmount,
          compareList: this.buildCompareList(data, 'refundAmount', type, 'trade')
        }, {
          key: 'grossMargin',
          label: '毛利率',
          value: this.formatPercentValue(data.grossMarginRate),
          unit: '%',
          tip: TRADE_METRIC_TIPS.grossMargin,
          compareList: this.buildCompareList(data, 'grossMarginRate', type, 'trade')
        }, {
          key: 'afterSale',
          label: '售后申请单量',
          value: this.formatNumberDisplay(afterSale),
          unit: '',
          tip: TRADE_METRIC_TIPS.afterSale,
          compareList: this.buildCompareList(data, 'aftersaleOrderCount', type, 'trade')
        }]
      };
    },
    applyUserFilter: function applyUserFilter() {
      var _this4 = this;
      this.fetchUserData().then(function (ok) {
        if (ok) _this4.$message.success('已应用筛选');
      });
    },
    applyTradeFilter: function applyTradeFilter() {
      var _this5 = this;
      this.fetchTransactionData().then(function (ok) {
        if (ok) _this5.$message.success('已应用筛选');
      });
    },
    fetchTrafficData: function () {
      var _fetchTrafficData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var params, res, _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              if ((0, _permission.checkPermi)(['admin:core:overview:traffic:data'])) {
                _context6.n = 1;
                break;
              }
              this.zoneUserLoading = false;
              return _context6.a(2, false);
            case 1:
              params = this.buildOverviewPeriodParams(this.zoneDateRange, this.zoneCustomRange);
              if (params) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2, false);
            case 2:
              if (this.decorationPageId != null && this.decorationPageId !== '') params.designAuthId = this.decorationPageId;
              this.zoneUserLoading = true;
              _context6.p = 3;
              _context6.n = 4;
              return (0, _statistic.overviewTrafficDataApi)(params);
            case 4:
              res = _context6.v;
              this.zoneUserMetrics = this.normalizeTrafficData(res, params.type);
              return _context6.a(2, true);
            case 5:
              _context6.p = 5;
              _t6 = _context6.v;
              this.zoneUserMetrics = emptyZoneUserMetrics(params.type);
              return _context6.a(2, false);
            case 6:
              _context6.p = 6;
              this.zoneUserLoading = false;
              return _context6.f(6);
            case 7:
              return _context6.a(2);
          }
        }, _callee6, this, [[3, 5, 6, 7]]);
      }));
      function fetchTrafficData() {
        return _fetchTrafficData.apply(this, arguments);
      }
      return fetchTrafficData;
    }(),
    applyZoneUserFilter: function applyZoneUserFilter() {
      var _this6 = this;
      this.fetchTrafficData().then(function (ok) {
        if (ok) _this6.$message.success('已应用筛选');
      });
    },
    normalizeTrafficData: function normalizeTrafficData(res, type) {
      var data = res && _typeof(res) === 'object' && !Array.isArray(res) ? res : {};
      var clickCount = this.pickNumber(data.clickCount, data.clicks, data.clickNum, data.clickQuantity);
      var browsePv = this.pickNumber(data.browsePv, data.pv, data.pageView, data.pageViews);
      return {
        list: [{
          key: 'clicks',
          label: '点击量',
          value: this.formatNumberDisplay(clickCount),
          unit: '',
          tip: ZONE_METRIC_TIPS.clicks,
          compareList: this.buildCompareList(data, ['clickCount', 'clicks'], type, 'user')
        }, {
          key: 'pv',
          label: '浏览PV',
          value: this.formatNumberDisplay(browsePv),
          unit: '',
          tip: ZONE_METRIC_TIPS.pv,
          compareList: this.buildCompareList(data, ['browsePv', 'pv'], type, 'user')
        }, {
          key: 'avgStay',
          label: '平均停留时长',
          value: data.averageDuration != null && data.averageDuration !== '' ? String(data.averageDuration) : '--',
          unit: '',
          tip: ZONE_METRIC_TIPS.avgStay,
          compareList: this.buildCompareList(data, 'averageDuration', type, 'user')
        }]
      };
    },
    fetchCartProductTop: function () {
      var _fetchCartProductTop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var customerIds, params, res, list, _t7;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              if ((0, _permission.checkPermi)(['admin:core:overview:cart:product:top'])) {
                _context7.n = 1;
                break;
              }
              this.cartLoading = false;
              return _context7.a(2);
            case 1:
              this.cartLoading = true;
              _context7.p = 2;
              customerIds = this.getCustomerIdsParam();
              params = {};
              if (customerIds) params.customerIds = customerIds;
              _context7.n = 3;
              return (0, _statistic.overviewCartProductTopApi)(params);
            case 3:
              res = _context7.v;
              list = Array.isArray(res) ? res : res && res.list || [];
              this.cartTop5 = {
                dataTime: this.pickDataUpdateTime(res),
                list: list.map(function (item) {
                  return {
                    name: item.productName || '--',
                    value: Number(item.cartQuantity) || 0,
                    productId: item.productId
                  };
                })
              };
              _context7.n = 5;
              break;
            case 4:
              _context7.p = 4;
              _t7 = _context7.v;
              this.cartTop5 = {
                dataTime: '--',
                list: []
              };
            case 5:
              _context7.p = 5;
              this.cartLoading = false;
              return _context7.f(5);
            case 6:
              this.buildCartOption();
            case 7:
              return _context7.a(2);
          }
        }, _callee7, this, [[2, 4, 5, 6]]);
      }));
      function fetchCartProductTop() {
        return _fetchCartProductTop.apply(this, arguments);
      }
      return fetchCartProductTop;
    }(),
    normalizeHourlyTrend: function normalizeHourlyTrend(res, date) {
      var hours = Array.from({
        length: 24
      }, function (_, i) {
        return String(i).padStart(2, '0') + ':00';
      });
      var visitUsers = Array(24).fill(null);
      var orderCounts = Array(24).fill(null);
      var list = Array.isArray(res) ? res : res && (res.list || res.data) || [];
      list.forEach(function (item) {
        var hourIdx = null;
        var h = item.hour;
        if (h == null || h === '') return;
        if (typeof h === 'string' && h.includes(':')) hourIdx = Number(h.split(':')[0]);else hourIdx = Number(h);
        if (hourIdx == null || Number.isNaN(hourIdx) || hourIdx < 0 || hourIdx > 23) return;
        if (item.visitUserCount != null && item.visitUserCount !== '') visitUsers[hourIdx] = Number(item.visitUserCount) || 0;
        if (item.orderCount != null && item.orderCount !== '') orderCounts[hourIdx] = Number(item.orderCount) || 0;
      });
      return {
        date: date,
        updateTime: this.pickDataUpdateTime(res),
        hours: hours,
        visitUsers: visitUsers,
        orderCounts: orderCounts,
        currentHourLabel: '当前时间'
      };
    },
    fetchOrderHourlyTrend: function () {
      var _fetchOrderHourlyTrend = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var date, customerIds, params, res, _t8;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              date = this.orderTrendDate || this.formatDateYmd(new Date());
              if (!this.orderTrendDate) this.orderTrendDate = date;
              _context8.p = 1;
              customerIds = this.getCustomerIdsParam();
              params = {
                date: date
              };
              if (customerIds) params.customerIds = customerIds;
              _context8.n = 2;
              return (0, _statistic.overviewHourlyTrendApi)(params);
            case 2:
              res = _context8.v;
              this.orderTrend = this.normalizeHourlyTrend(res, date);
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t8 = _context8.v;
              this.orderTrend = emptyHourlyTrend(date);
            case 4:
              this.buildOrderTrendOption();
            case 5:
              return _context8.a(2);
          }
        }, _callee8, this, [[1, 3]]);
      }));
      function fetchOrderHourlyTrend() {
        return _fetchOrderHourlyTrend.apply(this, arguments);
      }
      return fetchOrderHourlyTrend;
    }(),
    applyOrderTrend: function applyOrderTrend() {
      var _this7 = this;
      this.fetchOrderHourlyTrend().then(function () {
        _this7.$message.success('已应用');
      });
    },
    normalizeHourlyPayTrend: function normalizeHourlyPayTrend(res, date) {
      var hours = Array.from({
        length: 24
      }, function (_, i) {
        return String(i).padStart(2, '0') + ':00';
      });
      var visitUsers = Array(24).fill(null);
      var orderCounts = Array(24).fill(null);
      var list = Array.isArray(res) ? res : res && (res.list || res.data) || [];
      list.forEach(function (item) {
        var hourIdx = null;
        var h = item.hour;
        if (h == null || h === '') return;
        if (typeof h === 'string' && h.includes(':')) hourIdx = Number(h.split(':')[0]);else hourIdx = Number(h);
        if (hourIdx == null || Number.isNaN(hourIdx) || hourIdx < 0 || hourIdx > 23) return;
        if (item.visitUserCount != null && item.visitUserCount !== '') visitUsers[hourIdx] = Number(item.visitUserCount) || 0;
        if (item.payOrderCount != null && item.payOrderCount !== '') orderCounts[hourIdx] = Number(item.payOrderCount) || 0;
      });
      return {
        date: date,
        updateTime: this.pickDataUpdateTime(res),
        hours: hours,
        visitUsers: visitUsers,
        orderCounts: orderCounts,
        currentHourLabel: '当前时间'
      };
    },
    fetchPayHourlyTrend: function () {
      var _fetchPayHourlyTrend = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var date, customerIds, params, res, _t9;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              if ((0, _permission.checkPermi)(['admin:core:overview:hourly:pay:trend'])) {
                _context9.n = 1;
                break;
              }
              this.realtimeLoading = false;
              return _context9.a(2);
            case 1:
              date = this.realtimeDate || this.formatDateYmd(new Date());
              if (!this.realtimeDate) this.realtimeDate = date;
              this.realtimeLoading = true;
              _context9.p = 2;
              customerIds = this.getCustomerIdsParam();
              params = {
                date: date
              };
              if (customerIds) params.customerIds = customerIds;
              _context9.n = 3;
              return (0, _statistic.overviewHourlyPayTrendApi)(params);
            case 3:
              res = _context9.v;
              this.realtime = this.normalizeHourlyPayTrend(res, date);
              _context9.n = 5;
              break;
            case 4:
              _context9.p = 4;
              _t9 = _context9.v;
              this.realtime = emptyHourlyTrend(date);
            case 5:
              _context9.p = 5;
              this.realtimeLoading = false;
              return _context9.f(5);
            case 6:
              this.buildRealtimeOption();
            case 7:
              return _context9.a(2);
          }
        }, _callee9, this, [[2, 4, 5, 6]]);
      }));
      function fetchPayHourlyTrend() {
        return _fetchPayHourlyTrend.apply(this, arguments);
      }
      return fetchPayHourlyTrend;
    }(),
    applyRealtime: function applyRealtime() {
      var _this8 = this;
      this.fetchPayHourlyTrend().then(function () {
        _this8.$message.success('已应用');
      });
    },
    applyZoneTrend: function applyZoneTrend() {
      var _this9 = this;
      this.fetchHourlyTrafficTrend().then(function () {
        _this9.$message.success('已应用筛选');
      });
    },
    normalizeHourlyTrafficTrend: function normalizeHourlyTrafficTrend(res, date) {
      var _this0 = this;
      var hours = Array.from({
        length: 24
      }, function (_, i) {
        return String(i).padStart(2, '0') + ':00';
      });
      var pv = Array(24).fill(null);
      var clicks = Array(24).fill(null);
      var data = res && res.data;
      var page = res && res.page;
      var dataPage = data && data.page;
      var list = this.pickFirstArray(res, res && res.list, res && res.records, res && res.rows, res && res.result, page && page.list, page && page.records, data, data && data.list, data && data.records, data && data.rows, data && data.result, dataPage && dataPage.list, dataPage && dataPage.records, res && res.trendList, res && res.hourList, data && data.trendList, data && data.hourList);
      list.forEach(function (item) {
        if (!item) return;
        var h = _this0.pickValueByKeys(item, ['hour', 'statHour', 'dateHour', 'hourTime', 'time', 'statTime', 'statisticsTime', 'dataTime', 'dateTime']);
        var hourIdx = _this0.parseHourIndex(h);
        if (hourIdx == null || Number.isNaN(hourIdx) || hourIdx < 0 || hourIdx > 23) return;
        var pvVal = _this0.pickNumberByKeys(item, ['browsePv', 'browsePV', 'pv', 'pageView', 'pageViews', 'viewCount', 'viewNum', 'browseCount', 'browseNum', 'visitPv']);
        var clickVal = _this0.pickNumberByKeys(item, ['clickCount', 'clicks', 'clickNum', 'clickQuantity', 'clickTotal', 'clickTimes', 'clickPv', 'click']);
        if (pvVal != null) pv[hourIdx] = pvVal;
        if (clickVal != null) clicks[hourIdx] = clickVal;
      });
      var updateTime = this.pickDataUpdateTime(res);
      if (updateTime === '--' && list[0]) {
        updateTime = this.pickDataUpdateTime(list[0]);
        if (updateTime === '--' && list[0].dataUpdateTime) updateTime = list[0].dataUpdateTime;
      }
      return {
        date: date,
        updateTime: updateTime,
        hours: hours,
        pv: pv,
        clicks: clicks
      };
    },
    fetchHourlyTrafficTrend: function () {
      var _fetchHourlyTrafficTrend = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var date, customerIds, params, res, _t0;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              if ((0, _permission.checkPermi)(['admin:core:overview:hourly:traffic:trend'])) {
                _context0.n = 1;
                break;
              }
              this.zonePvLoading = false;
              return _context0.a(2);
            case 1:
              date = this.zoneTrendDate || this.formatDateYmd(new Date());
              if (!this.zoneTrendDate) this.zoneTrendDate = date;
              this.zonePvLoading = true;
              _context0.p = 2;
              customerIds = this.getCustomerIdsParam();
              params = {
                date: date
              };
              if (customerIds) params.customerIds = customerIds;
              if (this.decorationPageId != null && this.decorationPageId !== '') params.designAuthId = this.decorationPageId;
              _context0.n = 3;
              return (0, _statistic.overviewHourlyTrafficTrendApi)(params);
            case 3:
              res = _context0.v;
              this.zonePvTrend = this.normalizeHourlyTrafficTrend(res, date);
              _context0.n = 5;
              break;
            case 4:
              _context0.p = 4;
              _t0 = _context0.v;
              this.zonePvTrend = emptyZonePvTrend(date);
            case 5:
              _context0.p = 5;
              this.zonePvLoading = false;
              return _context0.f(5);
            case 6:
              this.buildZonePvOption();
              this.zonePvChartTick += 1;
              this.resizeCharts();
            case 7:
              return _context0.a(2);
          }
        }, _callee0, this, [[2, 4, 5, 6]]);
      }));
      function fetchHourlyTrafficTrend() {
        return _fetchHourlyTrafficTrend.apply(this, arguments);
      }
      return fetchHourlyTrafficTrend;
    }(),
    fetchDurationDistribution: function () {
      var _fetchDurationDistribution = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var customerIds, params, res, list, _t1;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              if ((0, _permission.checkPermi)(['admin:core:overview:duration:distribution'])) {
                _context1.n = 1;
                break;
              }
              this.zoneStayLoading = false;
              return _context1.a(2);
            case 1:
              this.zoneStayLoading = true;
              _context1.p = 2;
              customerIds = this.getCustomerIdsParam();
              params = {};
              if (customerIds) params.customerIds = customerIds;
              if (this.decorationPageId != null && this.decorationPageId !== '') params.designAuthId = this.decorationPageId;
              _context1.n = 3;
              return (0, _statistic.overviewDurationDistributionApi)(params);
            case 3:
              res = _context1.v;
              list = Array.isArray(res) ? res : res && res.list || [];
              this.zoneStay = {
                updateTime: this.pickDataUpdateTime(res),
                list: list.map(function (item) {
                  return {
                    name: item.durationRange || '--',
                    value: Number(item.count) || 0
                  };
                })
              };
              _context1.n = 5;
              break;
            case 4:
              _context1.p = 4;
              _t1 = _context1.v;
              this.zoneStay = {
                updateTime: '--',
                list: []
              };
            case 5:
              _context1.p = 5;
              this.zoneStayLoading = false;
              return _context1.f(5);
            case 6:
              this.buildZoneStayOption();
            case 7:
              return _context1.a(2);
          }
        }, _callee1, this, [[2, 4, 5, 6]]);
      }));
      function fetchDurationDistribution() {
        return _fetchDurationDistribution.apply(this, arguments);
      }
      return fetchDurationDistribution;
    }(),
    handleDownloadSource: function handleDownloadSource() {
      this.$message.info('暂无导出接口');
    },
    resizeCharts: function resizeCharts() {
      this.$nextTick(function () {
        setTimeout(function () {
          window.dispatchEvent(new Event('resize'));
        }, 50);
      });
    },
    buildDualHourlyOption: function buildDualHourlyOption(_ref2) {
      var hours = _ref2.hours,
        leftData = _ref2.leftData,
        rightData = _ref2.rightData,
        leftName = _ref2.leftName,
        rightName = _ref2.rightName,
        dateValue = _ref2.dateValue;
      var visitMax = Math.max.apply(Math, [0].concat(_toConsumableArray((leftData || []).map(function (v) {
        return v == null ? 0 : Number(v);
      }))));
      var orderMax = Math.max.apply(Math, [0].concat(_toConsumableArray((rightData || []).map(function (v) {
        return v == null ? 0 : Number(v);
      }))));
      var sharedMax = Math.max(visitMax, orderMax);
      var yMax = sharedMax > 0 ? Math.ceil(sharedMax * 1.2) : 10;
      var today = this.formatDateYmd(new Date());
      var currentHourIdx = -1;
      if (dateValue === today) currentHourIdx = new Date().getHours();else {
        for (var i = (leftData || []).length - 1; i >= 0; i -= 1) {
          if (leftData[i] != null || rightData && rightData[i] != null) {
            currentHourIdx = i;
            break;
          }
        }
      }
      var markHour = currentHourIdx >= 0 && hours ? hours[currentHourIdx] : null;
      return {
        color: ['#3b82f6', '#f59e0b'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        legend: {
          data: [leftName, rightName],
          right: 220,
          top: 0,
          icon: 'emptyCircle'
        },
        grid: {
          left: 60,
          right: 60,
          top: 50,
          bottom: 40
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: hours,
          axisLine: {
            lineStyle: {
              color: '#d1d5db'
            }
          },
          axisLabel: {
            color: '#6b7280',
            interval: 0,
            rotate: 0,
            fontSize: 11
          }
        },
        yAxis: [{
          type: 'value',
          name: leftName,
          min: 0,
          max: yMax,
          nameTextStyle: {
            color: '#6b7280'
          },
          axisLabel: {
            color: '#6b7280'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#e5e7eb'
            }
          }
        }, {
          type: 'value',
          name: rightName,
          min: 0,
          max: yMax,
          nameTextStyle: {
            color: '#6b7280'
          },
          axisLabel: {
            color: '#6b7280'
          },
          splitLine: {
            show: false
          }
        }],
        series: [{
          name: leftName,
          type: 'line',
          smooth: true,
          symbol: 'emptyCircle',
          symbolSize: 7,
          areaStyle: {
            color: 'rgba(59, 130, 246, 0.18)'
          },
          data: leftData,
          markLine: markHour ? {
            symbol: 'none',
            label: {
              formatter: '当前时间',
              position: 'insideEndTop',
              color: '#ef4444',
              fontSize: 12,
              fontWeight: 600
            },
            lineStyle: {
              color: '#ef4444',
              type: 'solid',
              width: 1
            },
            data: [{
              xAxis: markHour
            }]
          } : undefined
        }, {
          name: rightName,
          type: 'line',
          yAxisIndex: 1,
          smooth: true,
          symbol: 'emptyCircle',
          symbolSize: 7,
          data: rightData
        }]
      };
    },
    buildOrderTrendOption: function buildOrderTrendOption() {
      var _this$orderTrend = this.orderTrend,
        hours = _this$orderTrend.hours,
        visitUsers = _this$orderTrend.visitUsers,
        orderCounts = _this$orderTrend.orderCounts;
      this.orderTrendOption = this.buildDualHourlyOption({
        hours: hours,
        leftData: visitUsers,
        rightData: orderCounts,
        leftName: '访问用户数',
        rightName: '下单订单数',
        dateValue: this.orderTrendDate
      });
    },
    buildRealtimeOption: function buildRealtimeOption() {
      var _this$realtime = this.realtime,
        hours = _this$realtime.hours,
        visitUsers = _this$realtime.visitUsers,
        orderCounts = _this$realtime.orderCounts;
      this.realtimeOption = this.buildDualHourlyOption({
        hours: hours,
        leftData: visitUsers,
        rightData: orderCounts,
        leftName: '访问用户数',
        rightName: '支付订单数',
        dateValue: this.realtimeDate
      });
    },
    buildSourceOption: function buildSourceOption() {
      var list = this.visitSource[this.sourceMetric] || [];
      var names = list.map(function (i) {
        return i.name;
      }).reverse();
      var values = list.map(function (i) {
        return i.value;
      }).reverse();
      var percents = list.map(function (i) {
        return i.percent;
      }).reverse();
      this.sourceOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function formatter(params) {
            var p = params[0];
            return p.name + '<br/>' + p.seriesName + '：' + p.value + '（' + percents[p.dataIndex] + '%）';
          }
        },
        grid: {
          left: 90,
          right: 70,
          top: 10,
          bottom: 20
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'category',
          data: names,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#4b5563',
            fontSize: 12
          }
        },
        series: [{
          name: this.sourceMetric === 'visitUsers' ? '访问人数' : 'open',
          type: 'bar',
          barWidth: 14,
          itemStyle: {
            color: '#22c55e',
            barBorderRadius: [0, 8, 8, 0]
          },
          label: {
            show: true,
            position: 'right',
            color: '#374151',
            formatter: function formatter(p) {
              return p.value + '  ' + percents[p.dataIndex] + '%';
            }
          },
          data: values
        }]
      };
    },
    buildCartOption: function buildCartOption() {
      var list = this.cartTop5.list || [];
      var names = list.map(function (i) {
        return i.name;
      }).reverse();
      var values = list.map(function (i) {
        return i.value;
      }).reverse();
      var maxVal = Math.max.apply(Math, [0].concat(_toConsumableArray(values)));
      var xMax = maxVal > 0 ? Math.ceil(maxVal * 1.2) : 10;
      this.cartOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function formatter(params) {
            var p = params[0];
            if (!p) return '';
            return p.name + '<br/>' + p.seriesName + '：' + p.value;
          }
        },
        grid: {
          left: 12,
          right: 40,
          top: 20,
          bottom: 40,
          containLabel: true
        },
        xAxis: {
          type: 'value',
          min: 0,
          max: xMax,
          axisLabel: {
            color: '#6b7280'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#e5e7eb'
            }
          }
        },
        yAxis: {
          type: 'category',
          data: names,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#4b5563',
            fontSize: 12,
            interval: 0,
            formatter: function formatter(val) {
              if (!val) return '';
              return String(val).length > 16 ? String(val).slice(0, 16) + '...' : val;
            }
          }
        },
        series: [{
          name: '加购未下单',
          type: 'bar',
          barWidth: 18,
          itemStyle: {
            color: '#fb923c',
            barBorderRadius: [0, 8, 8, 0]
          },
          data: values
        }]
      };
    },
    buildZonePvOption: function buildZonePvOption() {
      var _this$zonePvTrend = this.zonePvTrend,
        hours = _this$zonePvTrend.hours,
        pv = _this$zonePvTrend.pv,
        clicks = _this$zonePvTrend.clicks;
      var pvMax = Math.max.apply(Math, [0].concat(_toConsumableArray((pv || []).map(function (v) {
        return v == null ? 0 : Number(v);
      }))));
      var clickMax = Math.max.apply(Math, [0].concat(_toConsumableArray((clicks || []).map(function (v) {
        return v == null ? 0 : Number(v);
      }))));
      var sharedMax = Math.max(pvMax, clickMax);
      var yMax = sharedMax > 0 ? Math.ceil(sharedMax * 1.2) : 10;
      this.zonePvOption = {
        color: ['#3b82f6', '#f59e0b'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        legend: {
          data: ['PV', '点击量'],
          right: 220,
          top: 0,
          icon: 'circle'
        },
        grid: {
          left: 56,
          right: 56,
          top: 50,
          bottom: 40,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: hours,
          axisLine: {
            lineStyle: {
              color: '#d1d5db'
            }
          },
          axisLabel: {
            color: '#6b7280',
            fontSize: 11,
            interval: 1,
            hideOverlap: true
          }
        },
        yAxis: [{
          type: 'value',
          name: '次数(PV)',
          min: 0,
          max: yMax,
          nameTextStyle: {
            color: '#6b7280'
          },
          axisLabel: {
            color: '#6b7280'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#e5e7eb'
            }
          }
        }, {
          type: 'value',
          name: '点击量',
          min: 0,
          max: yMax,
          nameTextStyle: {
            color: '#6b7280'
          },
          axisLabel: {
            color: '#6b7280'
          },
          splitLine: {
            show: false
          }
        }],
        series: [{
          name: 'PV',
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          areaStyle: {
            color: 'rgba(59, 130, 246, 0.18)'
          },
          data: pv
        }, {
          name: '点击量',
          type: 'line',
          yAxisIndex: 1,
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          lineStyle: {
            type: 'dashed'
          },
          data: clicks
        }]
      };
    },
    buildZoneStayOption: function buildZoneStayOption() {
      var list = this.zoneStay.list || [];
      var names = list.map(function (i) {
        return i.name;
      }).reverse();
      var values = list.map(function (i) {
        return i.value;
      }).reverse();
      var maxVal = Math.max.apply(Math, [0].concat(_toConsumableArray(values.map(function (v) {
        return Number(v) || 0;
      }))));
      var xMax = maxVal > 0 ? Math.ceil(maxVal * 1.2) : 10;
      this.zoneStayOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: 80,
          right: 40,
          top: 20,
          bottom: 40
        },
        xAxis: {
          type: 'value',
          name: '访问次数',
          min: 0,
          max: xMax,
          nameTextStyle: {
            color: '#6b7280'
          },
          axisLabel: {
            color: '#6b7280'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#e5e7eb'
            }
          }
        },
        yAxis: {
          type: 'category',
          data: names,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#4b5563'
          }
        },
        series: [{
          name: '访问次数',
          type: 'bar',
          barWidth: 18,
          itemStyle: {
            color: '#a78bfa',
            barBorderRadius: [0, 8, 8, 0]
          },
          label: {
            show: true,
            position: 'right',
            color: '#374151',
            formatter: function formatter(p) {
              return Number(p.value).toLocaleString();
            }
          },
          data: values
        }]
      };
    }
  }
};